import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import type { Department } from "@/types/department";

export type PublishConfirmMode = "role" | "user";

interface PublishPermissionConfirmDialogProps {
  open: boolean;
  mode: PublishConfirmMode;
  targetLabel: string;
  /** Role template mode only — lists departments that require approval. */
  approvalDepartments?: Department[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function PublishPermissionConfirmDialog({
  open,
  mode,
  targetLabel,
  approvalDepartments = [],
  onConfirm,
  onCancel,
}: PublishPermissionConfirmDialogProps) {
  const hasApprovalDepartments = approvalDepartments.length > 0;

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg">
        <DialogHeader className="text-right">
          <DialogTitle>تأكيد تفعيل نشر المحتوى</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3 pt-1 text-sm text-muted-foreground">
              {mode === "role" ? (
                <>
                  <p>
                    أنت على وشك تفعيل <strong>نشر المحتوى</strong> لدور{" "}
                    <strong>{targetLabel}</strong>.
                  </p>
                  <p>
                    في الدوائر التي <strong>لا</strong> تتطلب اعتمادًا، يمكن
                    حاملي هذا الدور النشر مباشرة.
                  </p>
                  {hasApprovalDepartments ? (
                    <>
                      <p>
                        في الدوائر التالية التي تتطلب اعتمادًا، يجب على
                        المحررين إرسال المحتوى للمراجعة قبل النشر — ما لم
                        يُمنح مستخدم تخصيصًا فرديًا:
                      </p>
                      <ul className="list-inside list-disc space-y-1 text-foreground">
                        {approvalDepartments.map((department) => (
                          <li key={department.id}>{department.nameAr}</li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <p>لا توجد دوائر تتطلب اعتمادًا حاليًا.</p>
                  )}
                </>
              ) : (
                <p>
                  أنت على وشك منح <strong>{targetLabel}</strong> تخصيص{" "}
                  <strong>نشر المحتوى</strong> فوق قالب دوره. هذا التخصيص يسمح
                  للمستخدم بالنشر مباشرة حتى في الدوائر التي تتطلب اعتمادًا.
                </p>
              )}
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-start">
          <Button type="button" variant="outline" onClick={onCancel}>
            إلغاء
          </Button>
          <Button type="button" onClick={onConfirm}>
            متابعة
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
